import salonImg1 from '@/assets/imgs/webp/salon1.webp';
import salonImg2 from '@/assets/imgs/webp/salon2.webp';
import salonImg3 from '@/assets/imgs/webp/salon3.webp';
import salonImg4 from '@/assets/imgs/webp/salon4.webp';
import salonImg5 from '@/assets/imgs/webp/salon5.webp';
import salonImg6 from '@/assets/imgs/webp/salon6.webp';
import salonImg7 from '@/assets/imgs/webp/salon7.webp';
import salonImg8 from '@/assets/imgs/webp/salon8.webp';
import salonImg9 from '@/assets/imgs/webp/salon9.webp';

export const pepeImgCarouselSrc = [
  'https://images.unsplash.com/photo-1721635513019-4dd5f5c18042?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1717137389747-d1d4ced6abc8?q=80&w=1025&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1721406769891-f2ba651401d9?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1721296381825-426cfb4dc450?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1721241843448-af1c8ade1835?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
];

export const salonImgCarouselSrc = [
  salonImg1,
  salonImg2,
  salonImg3,
  salonImg4,
  salonImg5,
  salonImg6,
  salonImg7,
  salonImg8,
  salonImg9,
];
